import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import E2EProfileCalculator from '../components/tools/E2EProfileCalculator';

const AutosarE2EToolPage = () => {
  return (
    <div className="min-h-screen" data-testid="autosar-e2e-tool-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="AUTOSAR E2E Profile Calculator"
        description="Compute (Protect) or verify (Check) the CRC and Counter fields for AUTOSAR End-to-End (E2E) communication protection Profiles 1, 2, 4, and 5."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="autosar-e2e-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <E2EProfileCalculator />
          <ToolGuideCta guidePath="/tools/autosar-e2e/guide" toolName="AUTOSAR E2E Profile Calculator" />
        </div>
      </section>
    </div>
  );
};

export default AutosarE2EToolPage;
